<template>
  <header :class="$style.header">
    <JumpcloudBrandmark
      :class="$style.logo"
      :scale="scale"
      type="jcLogoWordmarkTM"
    />
    <section :class="$style.center">
      <div
        v-if="!isVerifyStep && step !== 1"
        :class="$style.progressBar"
      >
        <div
          v-for="progressBarStep in progressBarSteps"
          :key="progressBarStep.step"
        >
          <ParagraphBody :class="$style.step">
            <Icon
              v-if="progressBarStep.step < step"
              icon="checkmark"
            />
            <span
              v-else
              :class="[$style.circle, {
                [$style.current]: progressBarStep.step === step
              }]"
            />
            {{ progressBarStep.label }}
          </ParagraphBody>
        </div>
      </div>
    </section>
    <section :class="$style.login">
      <ParagraphBody
        v-if="isVerifyStep"
        :class="$style.login"
      >
        "A very well made IdP that <strong>listens to customers</strong>."
      </ParagraphBody>
      <LoginLink
        v-else-if="step === 1"
        :class="$style.login"
      />
    </section>
  </header>
</template>

<script>
import { Icon, JumpcloudBrandmark, ParagraphBody } from '@jumpcloud/ui-components';
import { mapState } from 'vuex';
import LoginLink from 'client/signup/components/LoginLink.vue';
import debounce from 'lodash/debounce';

export default {
  name: 'StepHeader',

  components: {
    Icon,
    JumpcloudBrandmark,
    LoginLink,
    ParagraphBody,
  },

  props: {
    isVerifyStep: Boolean,
  },

  data() {
    return {
      progressBarSteps: [
        {
          step: 2,
          label: 'About You',
        },
        {
          step: 3,
          label: 'About your Company',
        },
        {
          step: 4,
          label: 'Create Account',
        },
      ],
      scale: 2,
    };
  },

  computed: {
    ...mapState(['step']),
  },

  mounted() {
    this.setScale();
    window.addEventListener('resize', debounce(this.setScale, 200));
  },

  destroyed() {
    window.removeEventListener('resize', this.setScale);
  },

  methods: {
    setScale() {
      this.scale = window.innerWidth <= 768 ? 1 : 2;
    },
  },
};
</script>

<style module scoped>
@value (max-width-medium, max-width-small) from '~css/breakpoints.css';

.header {
  align-items: center;
  background: var(--jcWhite50);
  box-shadow: var(--jc-box-shadow);
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: var(--jc-spacer) 2.5rem;
  width: 100%;
}

.progressBar {
  align-items: center;
  display: grid;
  gap: var(--jc-spacer);
  grid-template-columns: repeat(3, max-content);
  justify-content: space-around;
}

.step {
  align-items: center;
  display: grid;
  gap: var(--jc-spacer-small);
  grid-template-columns: min-content auto;
}

.circle {
  background: var(--jc-color-background);
  border: var(--jc-border-width) solid var(--jc-color-neutral-text-base);
  border-radius: 50%;
  height: 1em;
  width: 1em;
}

.current {
  background: var(--jc-color-primary-fill-default);
  border: var(--jc-border-width) solid var(--jc-color-primary-fill-default);
}

.login {
  flex: 0 0 auto;
}

@media (max-width: max-width-small) {
  .progressBar {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: max-width-medium) {
  .header {
    height: var(--jc-size-3p5);
    padding: var(--jc-spacer-small) var(--jc-spacer);
  }

  .logo {
    padding-right: var(--jc-spacer);
  }

  .step.step {
    font-size: var(--jcBodySmall);
  }
}

@media (min-width: max-width-medium) {
  .center {
    width: 60%;
  }
}
</style>
